module.exports = __webpack_public_path__ + "static/media/plus-icon.0230e378.svg";